import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TokenInformationTabView } from '@app/feature/token/token-details/token-information-tab.view';
import { TokenTransactionListControllerWithContext } from '@app/feature/token/token-transaction-list/token-transaction-list.controller';

enum TabEnum {
  INFORMATION = 'information',
  TRANSACTIONS = 'transactions',
}

export const TokenDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () => [
      {
        title: t('$.token-details.information.title'),
        key: TabEnum.INFORMATION,
        icon: 'info-circle',
      },
      {
        title: t('$.token-details.transactions.title'),
        key: TabEnum.TRANSACTIONS,
        icon: 'price',
      },
    ],
    [t],
  );

  const { tab: currentTab, setTab: setCurrentTab } = useTabQuery(
    TabEnum.INFORMATION,
    extractTabKeys(tabs),
  );

  const renderTab = useMemo(() => {
    switch (currentTab) {
      case TabEnum.TRANSACTIONS:
        return <TokenTransactionListControllerWithContext />;
      case TabEnum.INFORMATION:
      default:
        return <TokenInformationTabView />;
    }
  }, [currentTab]);

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Tabs
        currentTab={currentTab}
        onTabClick={(tab) => setCurrentTab(tab)}
        elements={tabs}
      />
      {renderTab}
    </>
  );
};
